export default [
  [`Размер`, `XS`, `S`, `M`, `L`, `XL`, `2XL`],
  [`Российский размер`, `42`, `44`, `46`, `48`, `50`, `52`],
  [`Полуобхват в груди, см`, `42`, `44`, `46`, `48`, `50`, `52`],
  [`Длина, см`, `62`, `63`, `64`, `65`, `66`, `67`]
];
